import React from 'react'
import PropTypes from 'prop-types'
import { Typography, Box } from '@mui/material'

/**
 * Simple ErrorBoundary for widgets
 */
class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError (error) {
    return { hasError: true, error }
  }

  componentDidCatch (error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo)
  }

  render () {
    if (this.state.hasError) {
      return (
        <Box sx={{ p: 2, textAlign: 'center', color: 'error.main', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography variant='caption'>t_(Something went wrong.)</Typography>
        </Box>
      )
    }

    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node
}

export default ErrorBoundary
